import React from "react";
import faceImg from "../assets/faceImg.svg";
import twitImg from "../assets/twitImg.svg";
import instaImg from "../assets/instaImg.svg";
import linkImg from "../assets/linkImg.svg";
import footLogo from "../assets/logo.svg";


const Footer = () => {
  return (
    <div className="bg-[#001804] w-screen text-white py-[48px] px-[20px] flex flex-col xsm:px-5">
      <section className="flex flex-wrap gap-5 justify-around xsm:flex-col">
       <section className="flex items-center gap-3 mb-4">
        <img src={footLogo} alt="Internship Forum Jobs Logo" className="h-10 w-auto" />
        <span className="font-semibold text-lg tracking-tight">
          Your Gateway to Exciting Opportunities!
        </span>
      </section>
        <section className="foot-section flex flex-col">
        <span className="">Quick Links</span>

        <a href="#" className="hover:underline">Home</a>
        <a href="#stories" className="hover:underline">Our Stories</a>
        <a href="#impact" className="hover:underline flex items-center gap-1">
          Our Impact <span className="border rounded-full px-2 py-0.5 text-xs ml-1 text-yellow-800">New</span>
        </a>
        <a href="#faqs" className="hover:underline">FAQs</a>
        </section>
        <section className="foot-section flex flex-col">
          <span className="">Social</span>

          <a href="https://www.instagram.com/internshipforumjobs/" className="hover:underline">Instagram</a>
          <a href="https://www.linkedin.com/company/internship-forum-jobs" className="hover:underline">Linkedin</a>
          <map>Twitter</map>
          <map>Facebook </map>
          {/* <map>Instagram</map> */}

        </section>
        <section className="foot-section flex flex-col">
          <span className="">Legal</span>

          <map>Terms</map>
          <map>Privacy</map>
          <map>Cookies </map>
          <map>Licenses</map>
        </section>
      </section>
      <section className="flex justify-around xsm:flex-col md:items-end mt-[48px]">
        {" "}
        <span className="!text-sm">
          © 2025 Internship Forum Jobs. All rights reserved.{" "}
        </span>
        <div className="flex justify-between xsm:gap-2 xsm:justify-start my-2  gap-[45px]">
          <img src={faceImg} alt="Facebook Icon" className="cursor-pointer" />
          <img src={twitImg} alt="Twitter Icon" className="cursor-pointer" />
          <img src={linkImg} alt="Linkedin Icon" className="cursor-pointer" />
          <img src={instaImg} alt="Instagram Icon" className="cursor-pointer" />
        </div>
      </section>
    </div>
  );
};

export default Footer;
